import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { isMobile, isMobileOnly, isTablet } from 'mobile-device-detect';
import Hashids from 'hashids/cjs';
import { isAndroid, isIOS } from 'react-device-detect';
import VideoSource from '../VideoSource';
import Icon from '../Icon';
import Constants from '../../pages/App/constants';
import placeholder from '../../../config/placeholder.config';
import { saveItem, unsaveItem } from '../../pages/SavedItems/helper';
import './style.scss';
import ShareIntent from '../../utils/shareUtils';
import ShareItem from '../../models/ShareItem';
import { config } from '../../settings';
import { redirectAuth } from '../../utils/redirect';
import { Resize } from '../../utils/imageUtils';
const hashids = new Hashids('', 12);

const iconSize = 18;
class RelatedCard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOnSavedList: false, // TODO Need to set this on load -- should check against global list of saved items
    };
  }

  showComment = () => {
    console.log('Need to either change to item detail and scroll to comments section, or show a comment editor');
  };

  toggleSavedItem = (save) => {
    let { item, auth } = this.props;
    const { user } = auth;
    if (user) {
      item = JSON.parse(JSON.stringify(item));
      console.log('Toggling saved item for state:');
      if (save) {
        console.log('save');
        saveItem(user, 'article', item);
      } else {
        console.log('unsave');
        unsaveItem(item);
      }
      this.setState((prevState) => ({ isOnSavedList: !prevState.isOnSavedList }));
    } else {
      // FIXME The path should be the path of the item, not the current page
      redirectAuth(`${config.authEndPoint}/login?path=${encodeURI(window.location.href)}?action=save`);
    }
  };

  itemImage = () => {
    const { item } = this.props;
    if (item.largeImage) {
      return Resize.size(item.largeImage);
    } else if (item.image) {
      return Resize.size(item.image);
    }
    return placeholder.cigar.replace('/placeholder/', '/768x512/placeholder/');
  };

  renderSaveIcon = () => {
    const { isOnSavedList: itemSaved } = this.state;

    if (isIOS) {
      return (
        <Icon name={itemSaved ? 'bookmark' : 'bookmark-border'} vendor="material" size={iconSize} alt="save" />
      );
    }

    if (isAndroid) {
      return (
        <Icon name={itemSaved ? 'bookmark' : 'bookmark-border'} vendor="material" size={iconSize} alt="save" />
      );
    }

    return (
      <Icon name={itemSaved ? 'bookmark' : 'bookmark-border'} vendor="material" size={iconSize} alt="save" />
    );
  };

  renderShareIcon = () => {
    if (isIOS) {
      return (
        <Icon name={['fas', 'share']} vendor="fa" size={iconSize} alt="share" />
      );
    }

    return (
      <Icon name="share" vendor="material" size={iconSize} alt="share" />
    );
  };

  renderCommentIcon = () => {
    if (isIOS) {
      return (
        <Icon name="message-circle" size={iconSize} alt="comment" />
      );
    }

    if (isAndroid) {
      return (
        <Icon name="comment" vendor="material" size={iconSize} alt="comment" />
      );
    }

    return (
      <Icon name="comment" vendor="material" size={iconSize} alt="comment" />
    );
  };

  render() {
    const { item } = this.props;
    return (
      <div style={{ padding: isMobileOnly ? 0 : (isTablet ? 4 : 15) }}>
        <div className="related-item">
          <div className="image">
            <Link to={`/articles/${hashids.encode(item.id)}`}>
              {item.videoId
                ? (
                  <VideoSource
                    videoSrc={item.videoUrl}
                    scaleWidth="100%"
                    scaleHeight={isMobile ? 250 : 145}
                    placeholder={item.image}
                    title={item.title}
                  />
                )
                : (<img src={this.itemImage()} title={item.title} alt={item.title} />)}
            </Link>
            { (!item.videoId && Constants.cardStyle === 'One')
              ? (
                <div className="tg-item-overlay-link">
                  <Link className="tg-link-button" to={`/articles/${hashids.encode(item.id)}`}><Icon icon="open" color="white" size={Constants.sizeFontICon} alt="comment" /></Link>
                </div>
              ) : ''}

            { (!item.videoId && Constants.cardStyle === 'Two')
              ? (
                <div>
                  {' '}
                  <div className="tg-item-overlay-two" style={{ backgroundColor: Constants.cardStyleTwoBg && Constants.cardStyleTwoBg }}></div>
                  <div className="tg-buttons-holder"><Link className="tg-link-button" to={`/articles/${hashids.encode(item.id)}`}><Icon icon="open" color="white" size={Constants.cardStyleTwoIconSize} alt="comment" /></Link></div>
                </div>
              ) : ''}
          </div>

          <div className="name">
            <Link to={`/articles/${hashids.encode(item.id)}`}>
              <h4 dangerouslySetInnerHTML={{ __html: item.title }}></h4>
            </Link>
            <span dangerouslySetInnerHTML={{ __html: item.excerpt }}></span>
          </div>

          <div className="last" style={{ textAlign: 'right' }}>
            <span className="author" style={{ marginTop: 3, fontSize: '12px' }}>
              <Link>
                {/* <Avatar src={item.author.image} style={{ display: 'inline-block', height: 20, width: 20 }} /> */}
                {`By ${item.author}`}
              </Link>
            </span>
            <div className="icon" style={{ marginTop: -12, marginRight: -12 }}>
              <div className="btn-group" style={{ padding: 8 }}>
                <button className="btn-icon" onClick={this.toggleSavedItem}>
                  <div>
                    {this.renderSaveIcon()}
                  </div>
                </button>
              </div>
              {/* <div className="btn-group hide-350"> */}
              {/*  <button className="btn-icon" type="button" onClick={commentHandler}> */}
              {/*    <div> */}
              {/*      {this.renderCommentIcon()} */}
              {/*    </div> */}
              {/*  </button> */}
              {/* </div> */}
              <div className="btn-group" style={{ padding: 8 }}>
                <button
                  className="btn-icon"
                  onClick={() => {
                    ShareIntent.share(new ShareItem({
                      title: item.title, // FIXME These need to strip the HTML
                      text: item.intro,
                      path: 'article',
                      route: `/articles/${hashids.encode(item.id)}`,
                      image: item.image,
                    }));
                  }}
                >
                  <div>
                    {this.renderShareIcon()}
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RelatedCard.propTypes = {
  item: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    auth: state.get('auth').toJS(),
  };
}

export default connect(mapStateToProps)(RelatedCard);
